import { getOnboardingSessionId } from '@/helpers/onboardingSession'

export type SelfieLocationState = {
  sessionId: string
}

export function parseSelfieLocationState(state: unknown): SelfieLocationState | null {
  if (typeof state !== 'object' || state === null) {
    return null
  }
  const { sessionId } = state as Record<string, unknown>
  if (typeof sessionId !== 'string' || sessionId === '') {
    return null
  }
  return { sessionId }
}

export function resolveSelfieLocationState(
  state: unknown,
  search: string,
): SelfieLocationState | null {
  const fromState = parseSelfieLocationState(state)
  if (fromState) {
    return fromState
  }

  const sessionId = new URLSearchParams(search).get('sessionId')
  if (typeof sessionId === 'string' && sessionId !== '') {
    return { sessionId }
  }

  const storedSessionId = getOnboardingSessionId()
  if (storedSessionId !== null) {
    return { sessionId: storedSessionId }
  }

  return null
}
